import { Component, Mixins } from 'vue-property-decorator';

import {
    arrayDiff,
    getLanguageForCountry,
    ipCountryQuery,
    MagicConfigMixin,
} from '@gig/magic-common';
import { Language } from '@gig/magic-sdk/dist/adapter/users/language';
import { Country } from '@gig/magic-sdk/dist/adapter/users/getCountries';
import type { IDropdownOption } from '@gig/magic-ui-kit';

import { config } from '../../services';
import { LANGUAGE_UPDATED } from '@gig/magic-messages';
import { ISubscription } from '@gig/magic-message-bus/dist/base-bus';

@Component({
    name: 'language-select',
})
export default class LanguageSelectComponent extends Mixins(MagicConfigMixin) {
    currentLocale: Language | null = null;
    currentLocaleSubscription: ISubscription | null = null;
    /**
     * Will show only one english option for the following languages
     */
    engLocales: Language[] = [
        Language.BRITISH,
        Language.CANADIAN,
        Language.NEW_ZEALAND,
        Language.IRISH,
    ];

    engCountries: Country[] = [
        Country.UNITED_KINGDOM,
        Country.CANADA,
        Country.NEW_ZEALAND,
        Country.IRELAND,
    ];

    countryCode: Country | null = null;

    /**
     * Hides it if the user is country blocked
     */
    get enabled() {
        if (this.countryCode) {
            return !config.countries.lockedCountries.includes(this.countryCode);
        }

        return true;
    }

    get locales(): IDropdownOption[] {
        let availableLanguages = arrayDiff(
            config.languages.available,
            this.engLocales,
        );

        if (this.countryCode !== Country.SWEDEN) {
            availableLanguages = availableLanguages.filter(
                (language) => language !== Language.SWEDISH,
            );
        }

        return availableLanguages.map((lang: string) => ({
            name: this.$t(`language-select.language.${lang}`) as string,
            value: lang,
        }));
    }

    async created() {
        this.countryCode = await ipCountryQuery();
        this.currentLocaleSubscription = window.eventBus.subscribe<Language>(
            LANGUAGE_UPDATED,
            (e) => {
                this.currentLocale = e.payload!;
            },
            { replay: true },
        );
    }

    destroyed() {
        this.currentLocaleSubscription?.unsubscribe();
    }

    languageChanged() {
        let locale = this.currentLocale as Language;

        // TODO: GMW-247 Change this to language grouping instead of just English check
        if (
            !!this.countryCode &&
            locale === Language.ENGLISH &&
            this.engCountries.indexOf(this.countryCode) > -1
        ) {
            locale = getLanguageForCountry(this.countryCode);
        }

        this.$router.push({
            params: { language: locale },
        });
    }
}
